export default "__VITE_ASSET__vLFEUdjV__"